<script setup lang="ts">
import type { VTextField } from 'vuetify/components';
import AppTypography from './AppTypography.vue';

const attrs = useAttrs();

const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  hideDetails = undefined,
  label = '',
  placeholder = '',
  rounded = 'lg',
  variant = 'solo-filled',
  type = 'text',
  min = undefined,
  max = undefined,
  withCounter = false,
  dataTestid = 'text-field',
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  hideDetails?: VTextField['hideDetails'];
  label?: string;
  rounded?: string | number | boolean;
  placeholder?: string;
  variant?: VTextField['variant'];
  type?: VTextField['type'];
  min?: VTextField['min'];
  max?: VTextField['max'];
  withCounter?: boolean;
  dataTestid?: string;
}>();

const text = defineModel<string | number | null>();
</script>
<template>
  <v-text-field
    v-model="text"
    v-bind="attrs"
    flat
    :variant="variant"
    :hide-detail="hideDetails"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
    :rounded="rounded"
    :type="type"
    :min="min"
    :max="max"
    :data-testid="dataTestid"
  >
    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
    <template #append-inner>
      <slot name="append-inner" />
    </template>
  </v-text-field>
  <AppTypography
    v-if="withCounter && errorMessages.length === 0"
    type="caption-2"
    class="pl-4"
    style="color: rgb(var(--v-theme--tertiary)) !important"
    >{{ `${(text as string)?.length}/${max} characters` }}</AppTypography
  >
</template>

<style></style>
